import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#pagination" }),
    /*#__PURE__*/_createTextVNode(" Pagination ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " If you have too much data to display in one page, use pagination. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUINumberOfPagers = _resolveComponent("EUINumberOfPagers")
  const _component_EUIButtonsWithBackgroudColor = _resolveComponent("EUIButtonsWithBackgroudColor")
  const _component_EUISmallPagination = _resolveComponent("EUISmallPagination")
  const _component_EUIMoreElements = _resolveComponent("EUIMoreElements")
  const _component_EUIHidePaginWhenThereIsOnePg = _resolveComponent("EUIHidePaginWhenThereIsOnePg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUINumberOfPagers),
    _createVNode(_component_EUIButtonsWithBackgroudColor),
    _createVNode(_component_EUISmallPagination),
    _createVNode(_component_EUIMoreElements),
    _createVNode(_component_EUIHidePaginWhenThereIsOnePg)
  ], 64))
}